/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react';
import { AppstoreOutlined, GlobalOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Menu, Button } from 'antd';
import { Link, useLocation } from 'react-router-dom';

import arrowLeft from 'assets/svg/arrow-to-left.svg';
import arrowRight from 'assets/svg/arrow-to-right.svg';
import { ReactComponent as CalendarIcon } from 'assets/svg/calendar.svg';
import { ReactComponent as Customer } from 'assets/svg/customer.svg';
import { ReactComponent as Dashboard } from 'assets/svg/dashboard.svg';
import { ReactComponent as Product } from 'assets/svg/product-menu.svg';
import { ReactComponent as Report } from 'assets/svg/report.svg';
import { ReactComponent as Settings } from 'assets/svg/settings.svg';
import { ReactComponent as Warehouse } from 'assets/svg/warehouse.svg';
import { SidebarCollapse } from 'store/actions/ConfigAction';
import { ConfigContext } from 'store/context';
import Auxiliary from 'util/Auxiliary';

import SidebarLogo from './SidebarLogo';
import UserProfile from './UserProfile';
import { usePermissions } from '../../hooks/usePermissions';

function resolveSelectedKey(pathname, drawer, openDrawer) {
  if (drawer && openDrawer) return drawer;

  if (pathname.startsWith('/demo/v2/calendar')) return 'clinic';

  if (pathname.startsWith('/demo/v2/clinic-queue')) return 'clinic-queue';

  if (pathname.startsWith('/demo/v2/clinic-website')) return 'clinic-website';

  if (pathname.startsWith('/demo/v2/clinic-roadmap')) return 'clinic-roadmap';

  return pathname.split('/')[1];
}

function ClinicSidebarContent({ toogleSubmenu, drawer, openDrawer }) {
  const { pathname } = useLocation();

  const { can } = usePermissions();
  const {
    ConfigState: { statusCollapse: status },
    ConfigDispatch,
  } = useContext(ConfigContext);

  const selectedKeys = resolveSelectedKey(pathname, drawer, openDrawer);

  return (
    <Auxiliary>
      <Button
        type="primary"
        onClick={() => ConfigDispatch(SidebarCollapse())}
        className="omi-arrow-menu"
        shape="circle"
      >
        <img src={status ? arrowRight : arrowLeft} alt="arrow-left" />
      </Button>
      <SidebarLogo />
      <div className="omi-sidebar-content">
        <Menu selectedKeys={[selectedKeys]} mode="inline">
          <Menu.Item key="dashboard">
            <Link to="/dashboard" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <Dashboard />
              </div>
              <p>Bảng điều khiển</p>
            </Link>
          </Menu.Item>

          <Menu.Item key="clinic">
            <Link to="/demo/v2/calendar" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <CalendarIcon />
              </div>
              <p>Lịch hẹn</p>
            </Link>
          </Menu.Item>

          <Menu.Item key="clinic-queue">
            <Link to="/demo/v2/clinic-queue" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <AppstoreOutlined style={{ fontSize: 18 }} />
              </div>
              <p>Hàng chờ</p>
            </Link>
          </Menu.Item>

          <Menu.Item key="clinic-website">
            <Link to="/demo/v2/clinic-website" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <GlobalOutlined style={{ fontSize: 18 }} />
              </div>
              <p>Website</p>
            </Link>
          </Menu.Item>

          <Menu.Item key="clinic-roadmap">
            <Link to="/demo/v2/clinic-roadmap" onClick={() => toogleSubmenu('')}>
              <div className="omi-menu-icon inline-block">
                <UnorderedListOutlined style={{ fontSize: 18 }} />
              </div>
              <p>Lộ trình</p>
            </Link>
          </Menu.Item>

          {can('viewCustomerList') && (
            <Menu.Item key="customers">
              <Link to="/customers" onClick={() => toogleSubmenu('')}>
                <div className="omi-menu-icon inline-block">
                  <Customer />
                </div>
                <p>Bệnh nhân</p>
              </Link>
            </Menu.Item>
          )}

          {(can('viewProductList') || can('viewCategoryList') || can('viewUOMList') || can('viewTagList')) && (
            <Menu.Item key="product">
              <a href="#" onClick={() => toogleSubmenu('product')}>
                <div className="omi-menu-icon inline-block">
                  <Product />
                </div>
                <p>Sản phẩm</p>
              </a>
            </Menu.Item>
          )}

          {(can('viewInventoryList') || can('viewScrapList')) && (
            <Menu.Item key="stock">
              <a href="#" onClick={() => toogleSubmenu('stock')}>
                <div className="omi-menu-icon inline-block">
                  <Warehouse />
                </div>
                <p>Kho hàng</p>
              </a>
            </Menu.Item>
          )}

          {can('viewReportInventoryValuation') && (
            <Menu.Item key="report">
              <a href="#" onClick={() => toogleSubmenu('report')}>
                <div className="omi-menu-icon inline-block">
                  <Report />
                </div>
                <p>Báo cáo</p>
              </a>
            </Menu.Item>
          )}

          {can('viewSetting') ? (
            <Menu.Item key="setting">
              <Link to="/settings" onClick={() => toogleSubmenu('')}>
                <div className="omi-menu-icon inline-block">
                  <Settings />
                </div>
                <p>Cấu hình</p>
              </Link>
            </Menu.Item>
          ) : null}
        </Menu>
      </div>
      <div className="omi-sidebar-footer">
        <UserProfile />
      </div>
    </Auxiliary>
  );
}

export default ClinicSidebarContent;
